export default __webpack_public_path__ + "static/media/BIGGERSTARS.d2a36721.svg";